import React from 'react';
import { Link } from 'react-router-dom';
import { Translate, TranslateHTML, useTranslate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalFooterButtons,
  ModalFooterCancelButton,
  ModalFooterPrimaryButton,
  ModalHeader
} from '../../common/modal/Modal';
import LoadImage from '../../common/images/LoadImage';
import { getProfileUrlByStyle } from '../../common/cgi/cgi';
import DisclaimerTarget from '../../common/notifications/DisclaimerTarget';
import MarketingCopy from '../../common/options/MarketingCopy';
import StandardFeatures from '../../components/standardFeatures/StandardFeaures';
import FetchTrimFeatures from './FetchTrimFeatures';

const TrimFeaturesModal = props => {
  const translate = useTranslate();
  const {
    style,
    appResources,
    breakpoint,
    disclaimer,
    selections,
    disableCompare,
    onClose,
    onSelect
  } = props;

  const { trimName, marketingCopy, selected } = style;
  const header = translate('trim.modal.title', { trim: trimName });
  const url = getProfileUrlByStyle(style, appResources, false, breakpoint);

  const imageSection = (
    <div
      className={`small-12 columns features__image-container ${
        marketingCopy ? 'large-6' : ''
      }`}>
      <LoadImage url={url}>
        {({ isLoading }) => {
          if (isLoading) {
            return <div className="loader" />;
          }
          return <img alt={trimName} className="modal__image" src={url} />;
        }}
      </LoadImage>
    </div>
  );

  const searchParams = new URLSearchParams(
    style.id === selections.styleId
      ? { styleOne: selections.styleId }
      : { styleOne: selections.styleId, styleTwo: style.id }
  );

  const marketingCopySection = marketingCopy && (
    <div className="features__msrp large-6 small-12 columns">
      <div className="features__subtitle">
        <Translate value="component.pricing.from.no.asterisk" />{' '}
        <DisclaimerTarget disclaimer={disclaimer} className="msrp-subtitle">
          {style.totalMSRP}
        </DisclaimerTarget>
      </div>
      <TranslateHTML
        value="trim.features.highlights"
        as="div"
        className="features__title"
      />
      <MarketingCopy content={marketingCopy} className="features__highlight" />
      {!disableCompare && (
        <div style={{ padding: '10px 0', textAlign: 'center' }}>
          <Link
            to={`/trim/compare?${searchParams.toString()}`}
            className="button button--secondary stat-text-link"
            style={{ minWidth: '100%' }}
            data-dtm={translate('component.common.select.trim')}>
            <Translate value="component.trim.compare.trims" />
            <SvgIcon
              value="chevron-right"
              className="svg-icon--small trim__chevron-icon--hide"
            />
          </Link>
        </div>
      )}
    </div>
  );

  return (
    <Modal isOpen={true} contentLabel={header} onRequestClose={onClose}>
      <ModalHeader text={header} analyticsKey={trimName} onClose={onClose} />
      <ModalBody>
        <div className="small-12 columns">
          <div className="features__top row" id="features-top">
            {imageSection}
            {marketingCopySection}
          </div>
          <div className="features__standard-header">
            <Translate value="component.common.standard.features" />
          </div>
          <div className="features__standard-list">
            <FetchTrimFeatures
              style={style}
              render={({ features }) => (
                <StandardFeatures features={features} analyticsKey={trimName} />
              )}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalFooterButtons>
          {selected ? (
            <ModalFooterPrimaryButton onClick={onClose} data-dtm={trimName} />
          ) : (
            <React.Fragment>
              <ModalFooterCancelButton onClick={onClose} data-dtm={trimName} />
              <ModalFooterPrimaryButton onClick={onSelect} data-dtm={trimName}>
                <Translate value="component.trim.features.select" />
              </ModalFooterPrimaryButton>
            </React.Fragment>
          )}
        </ModalFooterButtons>
      </ModalFooter>
    </Modal>
  );
};

export default TrimFeaturesModal;
